
(function($) {
	
	"use strict";

	if($('.brator-coming-soon-counter').length){
		let dataTimer = $('.brator-coming-soon-counter').attr("data-options") 


		let {timer_year, timer_month, timer_day} = JSON.parse(dataTimer)
		

		// Set the date we're counting down to
		var countDownDate = new Date(`${timer_month} ${timer_day}, ${timer_year} 12:00:00`).getTime();
	
		// Update the count down every 1 second
		var x = setInterval(function() {
		
			// Get todays date and time
			var now = new Date().getTime();
		
			// Find the distance between now an the count down date
			var distance = countDownDate - now;
		
			// Time calculations for days, hours, minutes and seconds
			var days = Math.floor(distance / (1000 * 60 * 60 * 24));
			var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((distance % (1000 * 60)) / 1000);
		
			// Display the result in the element with id="demo"
		
			document.getElementById("days").innerText = days
			document.getElementById("hours").innerText = hours
			document.getElementById("minutes").innerText = minutes
			document.getElementById("seconds").innerText = seconds
		
		
			// If the count down is finished, write some text 
			if (distance < 0) {
				clearInterval(x);
				document.getElementById("demo").innerHTML = "EXPIRED";
			}
		}, 1000);
	}


})(window.jQuery);	